export default class UrlHelper {
  /**
   * @param url - UrlString. Example: /custom/{:param1}/{:param2}
   * @param params - Params object. Example: {
   *     param1 : 12,
   *     param2 : "update"
   * }
   * @returns string - Example: /custom/12/update
   */
  static create(url, params) {
    if (!params || typeof params !== 'object') {
      return url
    }

    const createArrayUrl = (key, params) => {
      let paramQuery = ''
      params.forEach(item => {
        paramQuery = `${paramQuery + (paramQuery ? '&' : '')}${key}[]=${item}`
      })

      return paramQuery
    }

    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        // eslint-disable-next-line no-param-reassign
        url = url.replace(
          new RegExp(`{:${key}}`, 'g'),
          Array.isArray(params[key])
            ? createArrayUrl(key, params[key])
            : params[key],
        )
      }
    }

    return url
  }

  static createQuery(url, params) {
    if (!params || typeof params !== 'object') {
      return url
    }

    let queryString = ''
    let separator = ''

    const addParamQuery = (k, p) => {
      const param = `${k}=${p}`
      queryString += queryString.length > 0 ? `&${param}` : param
    }

    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        if (Array.isArray(params[key])) {
          params[key].forEach((item, index) => {
            if (typeof item === 'object') {
              Object.keys(item).forEach(p => {
                addParamQuery(`${key}[${index}][${p}]`, item[p])
              })
            } else {
              addParamQuery(`${key}[]`, item)
            }
          })
        } else {
          addParamQuery(key, params[key])
        }
      }
    }

    if (queryString.length > 0) {
      const pos = url.indexOf('?')

      if (pos === -1) {
        separator = '?'
      } else if (pos !== url.length - 1) {
        separator = '&'
      }
    }

    return `${url}${separator}${queryString}`
  }

  static getPsfsQuery(payload, displayOptions) {
    if (typeof payload === 'object' && payload.hasOwnProperty('psfs')) {
      const qp = payload.psfs.queryParams(displayOptions)

      return qp.length > 0 ? `?${qp}` : ''
    }

    return ''
  }
}
